import {WalletTransferContext} from '#/components/wallet-transfer/wallet-transfer-context';
import {WalletTransferTab} from '#/components/wallet-transfer/wallet-transfer-tab';
import {ClassName, DefaultChildren} from '#/utils/utils';
import {CheckCircleIcon} from '@heroicons/react/24/solid';
import * as Tabs from '@radix-ui/react-tabs';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

const TabsTrigger: FunctionComponent<
  {
    tab: WalletTransferTab;
  } & DefaultChildren
> = ({tab, children}) => {
  const {completedTabs} = useContext(WalletTransferContext);

  const stepCompleted = completedTabs.includes(tab);
  const disabled = (() => {
    if (tab === WalletTransferTab.ACCOUNT) {
      return completedTabs.length > 1;
    }
    return !completedTabs.includes(WalletTransferTab.ACCOUNT) || completedTabs.includes(tab);
  })();

  return (
    <Tabs.Trigger
      className='capitalize pr-6 text-left text-gray-400 p-2 flex gap-2 items-center rounded-lg group data-[state=active]:bg-deepblue data-[state=active]:text-white data-[state=inactive]:hover:bg-gray-400 data-[state=inactive]:hover:text-white data-[state=active]:pointer-events-none disabled:hover:cursor-not-allowed'
      value={tab}
      data-stepcompleted={stepCompleted}
      disabled={disabled}
      {...({} as any)}
    >
      <CheckCircleIcon
        className={
          'w-5 h-5 stroke-transparent fill-gray-400 group-data-[state=active]:fill-white group-data-[stepcompleted=true]:fill-upgreen group-data-[state=inactive]:group-data-[stepcompleted=false]:group-hover:fill-white'
        }
      />
      {children}
    </Tabs.Trigger>
  );
};

export const WalletTransferTabsList: FunctionComponent<ClassName> = ({className}) => {
  const {t} = useTranslation('translation');

  return (
    <Tabs.List className={className} {...({} as any)}>
      <TabsTrigger tab={WalletTransferTab.ACCOUNT}>
        {t('pages.walletTransfer.sections.accountSelection.title')}
      </TabsTrigger>
      <TabsTrigger tab={WalletTransferTab.SHARELAND}>{t('pages.walletTransfer.sections.assets.title')}</TabsTrigger>
      <TabsTrigger tab={WalletTransferTab.STABLE}>{t('pages.walletTransfer.sections.stableToken.title')}</TabsTrigger>
      <TabsTrigger tab={WalletTransferTab.NATIVE}>{t('pages.walletTransfer.sections.nativeToken.title')}</TabsTrigger>
    </Tabs.List>
  );
};
